export const getBool = (zoom) => {
  if (zoom > 1) {
    return true;
  } else {
    return false;
  }
};
